import { useToolsStore } from '@app/analytics/store'
import { initMetaPixel, metaPixels } from '@shared/lib/meta-pixel'

export default defineNuxtPlugin(() => {
  const toolsStore = useToolsStore()

  const pixelIds = metaPixels.map(pixel => pixel.pixelId)

  initMetaPixel(pixelIds)
  toolsStore.setMetaPixelReady(true)
})
